import { calcExchangeVolumes } from './calculateItemMetrics';

// The planning-stop name for the exchange-bucket aggregation; calcStopTruckCubes is its only
// caller. Shares calcExchangeVolumes so the intangible exclusion stays in one place.
export const calcStopVolumes = calcExchangeVolumes;

// A stop with no orders (the route's start or end) arrives as calcStopVolumes' scalar 0.
const NO_CHANGE = { itemsCubes: 0, returnsCubes: 0, haulawayCubes: 0 };

// A stop's returns/exchanges list counts only when it names an order: an empty array, or the empty
// Postgres literal it can be stored as, is truthy but means none.
const isListed = (value) => (Array.isArray(value) ? value.length > 0 : !!value && value !== '{}');

export function calcStopTruckCubes(stops) {
    let truckCubes = 0;
    return stops?.map((stop) => {
        const cubes = stop.exchangeCubes || NO_CHANGE;

        if (stop.type === 'PICKUP') {
            if (isListed(stop.returns)) {
                truckCubes += cubes.returnsCubes;
            } else {
                truckCubes += cubes.itemsCubes;
            }
        } else if (stop.type === 'DROPOFF') {
            if (isListed(stop.exchanges)) {
                let cubeDiff = cubes.returnsCubes - cubes.itemsCubes;
                truckCubes += cubeDiff;
            } else if (isListed(stop.returns)) {
                truckCubes -= cubes.returnsCubes;
            } else {
                truckCubes -= cubes.itemsCubes;
            }
        }
        stop.totalTruckCubes = truckCubes;
        return stop;
    });
}
